import controllers from "venuescanner-js/services/controllers";

export const createCheckoutSession = async (thread) => {
  const response = await controllers.stripe.createCheckoutSession.post({
    threadId: thread._id,
  });
  const {
    data: { session },
  } = response;

  return session;
};
